import { PrismicAccordionSlice } from '../../../types/PrismicAccordionSlice'
import { asText } from '@prismicio/client'
import { useOnce } from '@dtx-company/true-common/src/hooks/useOnce'
import { useState } from 'react'

interface UsePrismicAccordionStateProps {
  shouldItemsStartExpanded: boolean
  items: PrismicAccordionSlice['items']
}

interface UsePrismicAccordionReturnValue {
  expandedItemsByTitle: Record<string, boolean>
  toggleExpandItem: (itemTitle: string) => void
}

export const usePrismicAccordionState = ({
  shouldItemsStartExpanded,
  items
}: UsePrismicAccordionStateProps): UsePrismicAccordionReturnValue => {
  const [expandedItemsByTitle, setExpandedItemsByTitle] = useState<Record<string, boolean>>(
    items.reduce((acc, item) => ({ ...acc, [asText(item.title) || '']: false }), {})
  )

  useOnce(() => {
    if (shouldItemsStartExpanded) {
      setExpandedItemsByTitle(
        items.reduce((acc, item) => ({ ...acc, [asText(item.title) || '']: true }), {})
      )
    }
  })

  const toggleExpandItem = (itemTitle: string): void => {
    setExpandedItemsByTitle(prevState => ({ ...prevState, [itemTitle]: !prevState[itemTitle] }))
  }

  return { expandedItemsByTitle, toggleExpandItem }
}
